import * as React from 'react';
import { format } from 'date-fns';
import { toastr } from 'react-redux-toastr';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from '../../../components/text/ErrorMessage';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { INotificationTemplateItem } from '../../../core';
import { Editor } from '@tinymce/tinymce-react';

interface FormProps {
  subject: string;
  messageTemplate: string;
}

const EmailTemplate: React.FunctionComponent<{
  templateDetails?: INotificationTemplateItem;
  isEdit: boolean;
  onSubmit: (data: any) => void;
}> = (props) => {
  const [editorvalue, setEditorValue] = React.useState(
    props.templateDetails?.messageTemplate || ''
  );
  const [textvalue, setTextValue] = React.useState();
  const [tabName, setTabName] = React.useState<string>('html');

  const [isEditView, setIsEditView] = React.useState<boolean>(props.isEdit);

  const { control, handleSubmit, errors, setValue, watch } = useForm<FormProps>(
    {
      reValidateMode: 'onChange',
      mode: 'onSubmit',
    }
  );

  React.useEffect(() => {
    if (!watch('messageTemplate') && props.templateDetails?.messageTemplate) {
      setValue('messageTemplate', props.templateDetails?.messageTemplate);
      setEditorValue(props.templateDetails?.messageTemplate);
    }
  }, []);

  const onChangeSource = (event: { target: { value: any } }) => {
    const source = event.target.value;
    setValue('messageTemplate', source);
    setTextValue(source);
  };

  const handleEditorChange = (e: any) => {
    setValue('messageTemplate', e.target.getContent());
    setEditorValue(e.target.getContent());
    setTextValue(e.target.getContent({ format: 'text' }));
  };

  const handleEditorInit = (e: any) => {
    setTextValue(e.target.getContent({ format: 'text' }));
  };

  const tabClick = (tab: string) => {
    setTabName(tab);
    if (tab === 'html') {
      setValue('messageTemplate', editorvalue);
    }
    if (tab === 'text') {
      setValue('messageTemplate', textvalue);
    }
  };

  const onCopy = () => {
    toastr.success('Success', 'Copied to clip board');
  };

  return (
    <>
      <div className="col-xl-7 col-12 bg-gray-100">
        <div className="px-4 py-4 bg-gray-100">
          <div className="tab-content" id="activity-tabContent">
            <div
              className="tab-pane fade show active"
              id="note"
              role="tabpanel"
              aria-labelledby="note-tab"
            >
              <div className="row align-items-end mb-3">
                <div className="col-sm-9 col-12">
                  <h6 className="mb-1">{props.templateDetails?.subject}</h6>

                  {props.templateDetails?.updatedAt && (
                    <div className="font-xs text-gray-500">
                      Last Updated:{' '}
                      {format(
                        new Date(props.templateDetails?.updatedAt),
                        'dd/MM/yyyy hh:mm a'
                      )}
                      {/* <span>.</span>
                      Ajith E Palakkad */}
                    </div>
                  )}
                </div>
                <div className="col-sm-3 col-12 text-sm-right">
                  {isEditView && (
                    <div
                      onClick={() => setIsEditView(false)}
                      className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border mr-2"
                    >
                      <i className="icon-visibility"></i>
                    </div>
                  )}
                  {!isEditView && (
                    <div
                      onClick={() => setIsEditView(true)}
                      className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border"
                    >
                      <i className="icon-edit"></i>
                    </div>
                  )}
                </div>
              </div>
              {!isEditView ? (
                <div
                  className="template w-100 bg-white px-3 py-4"
                  dangerouslySetInnerHTML={{
                    __html: props.templateDetails?.messageTemplate || '',
                  }}
                ></div>
              ) : (
                <>
                  <form onSubmit={handleSubmit(props.onSubmit)}>
                    <div className="col-sm-12 col-12 py-4 bg-white">
                      <div className="form-group font-weight-semibold mb-4">
                        <label htmlFor="" className="font-sm text-uppercase">
                          Subject<span className="text-danger">*</span>
                        </label>

                        <Controller
                          control={control}
                          rules={{
                            required: true,
                            validate: (value) => {
                              return !!value.trim();
                            },
                            maxLength: 100,
                          }}
                          name="subject"
                          defaultValue={props.templateDetails?.subject}
                          render={({ onChange, value, name }) => (
                            <input
                              type="text"
                              className="form-control rounded-sm font-weight-semibold"
                              placeholder="Subject"
                              name={name}
                              value={value}
                              onChange={onChange}
                              id="subject"
                            />
                          )}
                        />
                        {errors.subject && (
                          <ErrorMessage>Subject is required</ErrorMessage>
                        )}
                      </div>
                      <Controller
                        control={control}
                        name="messageTemplate"
                        defaultValue={props.templateDetails?.messageTemplate}
                        render={() => <></>}
                      />
                      <ul
                        className="nav tab-underline mb-4 border-bottom font-xs font-weight-semibold col"
                        id="activity-tab"
                        role="tablist"
                      >
                        <li className="nav-item mr-4" role="presentation">
                          <a
                            className={classnames({
                              'cursor-pointer nav-link position-relative px-0 py-2 text-gray-600': true,
                              active: tabName === 'html',
                            })}
                            id="note-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="note"
                            aria-selected="true"
                            onClick={() => tabClick('html')}
                          >
                            <span className="py-1 d-inline-flex">Html</span>
                          </a>
                        </li>
                        {/* <li className="nav-item mr-4" role="presentation">
                          <a
                            className={classnames({
                              'cursor-pointer nav-link position-relative px-0 py-2 text-gray-600': true,
                              active: tabName === 'text',
                            })}
                            id="activity-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="activity"
                            aria-selected="true"
                            onClick={() => tabClick('text')}
                          >
                            <span className="py-1 d-inline-flex">Text</span>
                          </a>
                        </li> */}
                      </ul>
                      <div
                        className={classnames({
                          hide: tabName !== 'html',
                        })}
                      >
                        <Editor
                          apiKey="7r8sqonkgnawxp5rxne5153dda4drzl8wxnhp6v105zjgtyv"
                          init={{
                            height: 300,
                            menubar: true,
                            branding: false,
                            statusbar: false,
                            plugins: [
                              'lists link image paste help wordcount code',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor forecolor | alignleft aligncenter alignright alignjustify |  bullist numlist outdent indent | removeformat ',
                          }}
                          initialValue={props.templateDetails?.messageTemplate}
                          onChange={handleEditorChange}
                          onInit={handleEditorInit}
                        />

                        {/* <RichTextEditor
                          toolbarConfig={toolbarConfig}
                          value={editorvalue}
                          className="new-note-editor"
                          onChange={(html: any) => {
                            setValue('messageTemplate', html);
                            setEditorValue(html);
                          }}
                        /> */}
                      </div>

                      <div
                        className={classnames({
                          hide: tabName !== 'text',
                        })}
                      >
                        <div className="row">
                          <div className="col-12">
                            <textarea
                              className="source form-control"
                              placeholder="Editor Source"
                              value={textvalue}
                              onChange={onChangeSource}
                            />
                          </div>
                        </div>
                      </div>
                      {errors.messageTemplate && (
                        <ErrorMessage>
                          Message Template is required
                        </ErrorMessage>
                      )}
                      <div className="pb-2 pt-3 text-right">
                        <button
                          onClick={() => setIsEditView(false)}
                          className="btn btn-outline-dark font-normal font-weight-semibold py-2 px-4 mr-1"
                        >
                          Cancel
                        </button>
                        <button className="btn btn-primary font-normal font-weight-semibold py-2">
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-5 col-12 accordion p-4 bg-gray-100">
        {props.templateDetails?.placeholders && isEditView && (
          <div className="bg-white col-12 px-0">
            <div className="d-flex align-items-center py-3">
              <div className="col">
                <h4 className="font-weight-semibold mb-2">
                  Place Holder Values
                </h4>
                <p className="font-sm text-gray-500 mb-0">
                  To add value dynamically based on users, vehicles and others.
                  Use the following placeholders.
                </p>
              </div>
            </div>
            <div className="grid-table grid-table--sm border-top">
              <table>
                <tbody>
                  {props.templateDetails?.placeholders?.map((item: any) => {
                    return (
                      <tr className="cursor-pointer placeholder-row">
                        <td>{item.displayName}</td>
                        <td className="text-gray-500">
                          <span className="mr-1">:</span>
                          {item.value}
                        </td>
                        <td className="text-right">
                          <CopyToClipboard text={item.value} onCopy={onCopy}>
                            <button className="bg-gray-100 border btn font-weight-semibold font-xxs px-2 py-1 text-gray-600">
                              <i className="icon-copy d-xl-none"></i>
                              <span className="d-xl-block d-none">
                                Copy to clipboard
                              </span>
                            </button>
                          </CopyToClipboard>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EmailTemplate;
